<template>
  <div class="detail">
    <div class="header">
      <div class="title">获取区域内设施</div>
      <div class="extra" @click="cancel">
        <a-icon type="close" />
      </div>
    </div>

    <div class="body">
        <div class="status-info">
            <div class="status-dot"></div>
            <span>{{message}}</span>
        </div>
      <div style="padding-top: 1em"></div>
      <a-radio-group v-model="selected">
        <a-radio value="矩形">矩形</a-radio>
        <a-radio value="圆形">圆形</a-radio>
        <a-radio value="多边形">多边形</a-radio>
      </a-radio-group>

      <div class="center">
          <button class="btn btn-secondary" @click="clear">清除</button>
<!--          <button class="btn btn-primary" @click="testMockExport" type="primary">导出CAD文件</button>-->
          <button class="btn btn-primary" @click="exportToCAD" type="primary">导出CAD文件</button>
      </div>

<!--      <div v-if="facilitiesInArea.length > 0" class="result-section">-->
<!--          <h4>选中区域内的设施 ({{facilitiesInArea.length}}个)</h4>-->
<!--          <div class="facility-list">-->
<!--              <div v-for="(facility, index) in facilitiesInArea" :key="index" class="facility-item">-->
<!--                  {{ facility.type }} - : {{ facility }}-->
<!--              </div>-->
<!--          </div>-->
<!--      </div>-->


    </div>
  </div>
</template>

<script>
import router from "@/router";
export default {
  props: {
    overlays: {
      type: Array,
      default: () => [],
    },
    mouseTool: {},
    sewagePipeData: {
        type: Array,
        default: () => [],
    },
    rainPipeData: {
        type: Array,
        default: () => [],
    }
  },
  data() {
    return {
      selected: 'rectangle',
      mockPipeList: [
          {
              type: 'sewage',
              startLng: 120.65,
              startLat: 31.30,
              endLng: 120.66,
              endLat: 31.31,
              diameter: 300,
              material: 'HDPE',
              length: 1200
          },
          {
              type: 'rain',
              startLng: 120.64,
              startLat: 31.29,
              endLng: 120.65,
              endLat: 31.30,
              diameter: 500,
              material: '钢筋混凝土',
              length: 950
          }
      ],
      facilitiesInArea: [],
      areaBounds: null
    };
  },
  computed: {
    message() {
      if (this.selected === "矩形" || this.selected === "圆形") {
        return "请用鼠标在地图上左键按住一个位置开始拖动";
      } else if (this.selected === "多边形") {
        return "请点击地图任意位置，结束多边形绘制，请点击鼠标右键";
      } else {
        return "选择图形";
      }
    },
  },
  watch: {
    selected() {
      if (this.selected === "矩形") {
        this.mouseTool?.rectangle({
          fillColor: "#00b0ff",
          strokeColor: "#80d8ff",
          //同Polygon的Option设置
        });
      } else if (this.selected === "圆形") {
        this.mouseTool?.circle({
          fillColor: "#00b0ff",
          strokeColor: "#80d8ff",
          //同Circle的Option设置
        });
      } else if (this.selected === "多边形") {
        this.mouseTool?.polygon({
          fillColor: "#00b0ff",
          strokeColor: "#80d8ff",
          //同Polygon的Option设置
        });
      }
    },
    overlays(newVal) {
        if (newVal.length > 0) {
            // 当绘制完成时，自动计算区域内的设施
            this.calculateFacilitiesInArea();
        }
    }
  },
  methods: {
    testMockExport(){
        router.push('/cad1');
    },
    cancel() {
        this.selected = null;
        this.facilitiesInArea = [];
        this.$emit("cancel");
    },
    clear() {
        this.facilitiesInArea = [];
        this.areaBounds = null;
        this.$emit("clear");
    },
    calculateFacilitiesInArea() {
        if (!this.overlays.length || !window.AMap) return;

        const { AMap } = window;
        const overlay = this.overlays[0];

        // 获取区域的边界
        let bounds = null;
        if (overlay instanceof AMap.Rectangle) {
            bounds = overlay.getBounds();
        } else if (overlay instanceof AMap.Circle) {
            const center = overlay.getCenter();
            const radius = overlay.getRadius();
            bounds = new AMap.Bounds(
                [center.lng - radius/111000, center.lat - radius/111000],
                [center.lng + radius/111000, center.lat + radius/111000]
            );
        } else if (overlay instanceof AMap.Polygon) {
            const path = overlay.getPath();
            bounds = new AMap.Bounds();
            path.forEach(point => {
                bounds.extend(point);
            });
        }

        this.areaBounds = bounds;

        // 通知父组件查询区域内的设施
        this.$emit("query-area", bounds);
    },
    query() {
        if (!this.areaBounds) {
            this.$message.warning('请先在地图上绘制区域');
            return;
        }

        // 触发父组件的查询
        this.$emit("query", this.areaBounds);
    },
    exportToCAD() {
        if (this.facilitiesInArea.length === 0) {
            this.$message.warning('没有可导出的设施数据');
            return;
        }
        this.facilitiesInArea = this.convertToCadFacilities(this.facilitiesInArea);
        // 将所有设施数据传递给父组件进行导出
        this.$emit("export-cad", this.facilitiesInArea);
        // router.push('/cad1');
    },
      convertToCadFacilities(list) {
          return list.map(item => {
              const isPipe = /pipe$/i.test(item.type);   // 以 pipe 结尾
              // const isWell = /well$/i.test(item.type);   // 以 well 结尾

              return {
                  name: item.code,
                  nums: isPipe
                      ? Number(item.diameter || 0)
                      : Number(item.elevation || 0),
                  nums1: isPipe
                      ? 0
                      : Number(item.depth || 0),
                  diameter: isPipe ? 3 : 5,
                  points: isPipe
                      ? [
                          { longitude: Number(item.startX), latitude: Number(item.startY) },
                          { longitude: Number(item.endX),   latitude: Number(item.endY) }
                      ]
                      : [
                          { longitude: Number(item.x), latitude: Number(item.y) }
                      ]
              };
          });
      },
    // 接收父组件传入的设施数据
    setFacilitiesInArea(facilities) {
        this.facilitiesInArea = facilities;
    }
  },
};
</script>


<style lang="less" scoped>
.detail {
  position: fixed;
  top: 11vh;
  right: calc(1vw + 140px);
  z-index: 99;
  background-color: var(--detail-bgcolor);
  width: 20vw;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  border: 1px solid #073d3c;
  & > .header {
    background-color: var(--default-bgcolor);
    color: #00ff96;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1vw;
    line-height: 4vh;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .body {
    padding: 1em;
    .center {
      margin-top: 2em;
    }
  }

  .status-info {
    display: flex;
    align-items: center;
    gap: 1rem;
    color: #d5d5d5;
    font-size: 0.9rem;
    border: 1px dashed #255f47;
    padding:1rem;
    border-radius: 10px;
  }

  .status-dot {
    width: 8px;
    height: 8px;
    background: #00ff96;
    border-radius: 50%;
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0% { box-shadow: 0 0 0 0 rgba(0, 255, 150, 0.5); }
    70% { box-shadow: 0 0 0 10px rgba(0, 255, 150, 0); }
    100% { box-shadow: 0 0 0 0 rgba(0, 255, 150, 0); }
  }
}
::v-deep .ant-radio-wrapper{
  color: #b9b9b9;
}

.btn-secondary {
  background: rgba(20, 35, 70, 0.5);
  border: 1px solid rgba(0, 255, 150, 0.3);
  color: #00ff96;
  coursor: pointer;
}
.btn-secondary:hover {
  background: rgba(0, 255, 150, 0.1);
}
.btn-primary {
  background: linear-gradient(135deg, #00ff96, #00d4ff);
  color: #0a0e27;
  font-weight: 600;
  coursor: pointer;
}
.btn-primary:hover {
  box-shadow: 0 0 10px 0 rgba(0, 255, 150, 0.5);
}
.btn {
  padding: 0.5rem 1.2rem;
  border-radius: 8px;
  text-decoration: none;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-right: 25px;
}
</style>